var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('portal',{attrs:{"to":"modals"}},[_c('div',{staticClass:"modal fixed absolute--fill touch overflow-auto relative",class:_vm.style},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }